import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Extras";
import { BLOG_POSTS } from "../data/content";

const Blog = ({ posts = BLOG_POSTS }) => (
    <section id="consejos" data-testid="blog-section" className="bg-white py-12 md:py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <Reveal className="max-w-2xl">
                <p className="text-sm font-bold uppercase tracking-widest text-brand-magenta">Consejos LoloPets</p>
                <h2 className="mt-3 font-display text-3xl font-bold tracking-tight text-brand-ink sm:text-4xl">
                    Aprende a cuidar mejor a tu mascota
                </h2>
            </Reveal>
            <div className="mt-8 grid gap-6 md:grid-cols-3">
                {posts.map((post, i) => (
                    <Reveal key={post.url} delay={0.08 * i}>
                        <Link
                            data-testid={`blog-card-${i}`}
                            to={`/blog/${post.slug}`}
                            className="group flex h-full flex-col overflow-hidden rounded-2xl border border-black/5 bg-white shadow-soft transition-all duration-300 hover:-translate-y-1 hover:shadow-lift"
                        >
                            <div className="overflow-hidden bg-black/[0.03]">
                                <img
                                    src={post.image}
                                    alt={post.title}
                                    loading="lazy"
                                    className={`aspect-[4/3] w-full transition-transform duration-500 group-hover:scale-105 ${post.image?.includes("/v1/fit/") ? "object-contain p-4" : "object-cover"}`}
                                />
                            </div>
                            <div className="flex flex-1 flex-col p-6">
                                <h3 className="font-display text-lg font-semibold leading-snug text-brand-ink transition-colors duration-200 group-hover:text-brand-magenta">
                                    {post.title}
                                </h3>
                                <p className="mt-2 flex-1 text-sm leading-relaxed text-brand-muted">{post.excerpt}</p>
                                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-brand-magenta">
                                    Leer consejo <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" />
                                </span>
                            </div>
                        </Link>
                    </Reveal>
                ))}
            </div>
            <Reveal delay={0.15} className="mt-8 text-center">
                <Link
                    data-testid="blog-view-all"
                    to="/blog"
                    className="inline-flex min-h-[44px] items-center gap-2 rounded-full border-2 border-brand-magenta/30 bg-white px-8 py-3 font-display font-semibold text-brand-magenta transition-all duration-300 hover:-translate-y-0.5 hover:border-brand-magenta"
                >
                    Ver todos los consejos <ArrowRight className="h-4 w-4" />
                </Link>
            </Reveal>
        </div>
    </section>
);

export default Blog;
